import ProductInfoContainer from 'pricing-pages-lib/js/components/ProductInfoContainer.tsx';
import { useIsMobile } from 'pricing-pages-lib/js/context/IsMobileContext.tsx';
import { NavMarker } from 'react-rhumb';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import MobileWrapper from '../mobile/containers/MobileWrapper';
import HeaderLayout from './HeaderLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HeaderLayoutWrapper = props => {
  const isMobile = useIsMobile();
  const isAppReady = useGlobalLoading();
  if (isMobile) {
    return /*#__PURE__*/_jsx(MobileWrapper, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-id": "page-success",
    children: [isAppReady && /*#__PURE__*/_jsx(NavMarker, {
      name: props.navMarkerName
    }), /*#__PURE__*/_jsx(HeaderLayout, {
      selectedNavItem: props.navItem,
      children: /*#__PURE__*/_jsx(ProductInfoContainer, {
        children: props.children
      })
    })]
  });
};
export default HeaderLayoutWrapper;